// extracted by mini-css-extract-plugin
module.exports = {"modal":"IosInstallPrompt_modal__uwfvF","subtitle":"IosInstallPrompt_subtitle__2wVLK","header":"IosInstallPrompt_header__zEhuq","example":"IosInstallPrompt_example__FeijJ"};